export default __webpack_public_path__ + "static/media/DOM-JUNE2025.f86c2ef8.png";